export var DataSource;
(function (DataSource) {
    DataSource[DataSource["Playfab"] = 1] = "Playfab";
    DataSource[DataSource["Nexus"] = 2] = "Nexus";
})(DataSource || (DataSource = {}));
